export class WorkflowResultDTO {
  activityId: number;
  transactionId: number;
  workflowStep: string;
  result: string;
  isManualIntervention: boolean;
  createdBy: string;
}
